import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getTheme } from 'helpers/helpers';
import { removeAccessToken, setAccessToken } from 'helpers/token';
import { useHistory } from 'react-router-dom';
import callApi from 'helpers/callapi';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

// Components
import { Horizontal, Vertical } from 'components/Centered';
import { Checkbox, message, Spin, Modal, Button } from 'antd';
import { get } from 'lodash';
import VideoModal from 'components/VideoModal';

// import { UserOutlined, LockOutlined } from '@ant-design/icons';

export default function () {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loggingIn, setLoggingIn] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState();
  const [passwordError, setPasswordError] = useState();
  const [isResetPasswordState, setIsResetPasswordState] = useState(false);

  const [isCheckedConsent, setIsCheckedConsent] = useState(false);
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false);

  useEffect(() => {
    const verify = async () => {
      try {
        const me = await callApi({ url: '/users/me' });
        if (me.role !== 'center' && me.role !== 'center_staff') {
          window.location.href = 'https://tc65internal.com/credential';
          return;
        }
        dispatch({ type: 'UPDATE_USER', data: me });
        if (me.role === 'super') {
          history.replace('/dashboard');
        } else {
          history.replace('/site');
        }


      } catch (error) {
        console.log(error);
        removeAccessToken();
        dispatch({ type: 'UPDATE_USER', data: null });

        // history.replace('/login');
      }
    };

    verify();
  }, []);

  const onLogin = async () => {
    if (!isCheckedConsent) return;
    if (loggingIn) return;
    const _emailError = !email && 'กรุณากรอกข้อมูลชื่อบัญชีผู้ใช้';
    const _passwordError = !password && 'กรุณากรอกข้อมูลรหัสผ่าน';

    setEmailError(_emailError);
    setPasswordError(_passwordError);

    if (![_emailError, _passwordError].some((_error) => _error)) {
      setLoggingIn(true);
      try {
        const { accessToken } = await callApi({
          method: 'POST',
          url: '/users/login',
          body: { email, password },
        });

        setAccessToken(accessToken);
        // history.replace('/students');
        setTimeout(() => {
          // setLoggingIn(false);
          window.location.href = '/site';
        }, 1000);
      } catch (error) {
        console.error('Error while trying to login.', error);
        setLoggingIn(false);
        message.error(get(error, 'reason.message') || 'Unable to login, please try again later.');
      }
    }
  };

  const onResetPassword = async () => {
    const _emailError = !email && 'กรุณากรอกข้อมูลชื่อบัญชีผู้ใช้';
    setEmailError(_emailError);

    if (![_emailError].some((_error) => _error)) {
      try {
        await callApi({
          method: 'POST',
          url: '/users/forgot-password',
          body: { email },
        });
        Modal.success({
          content: 'ระบบได้ส่งวิธีการสำหรับการรีเซ็ตรหัสผ่านไปทางอีเมลเรียบร้อยแล้ว',
        });
      } catch (error) {
        setLoggingIn(false);

        message.error(get(error, 'reason.message') || 'Unable to reset password, please try again later.');
      }
    }
  };

  const _onKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (isResetPasswordState) {
        onResetPassword();
      } else {
        onLogin();
      }
    }
  };

  const onShowModal = (e) => {
    e.preventDefault();

    Modal.info({
      title: '',
      icon: <span></span>,
      width: 800,
      okText: <b>รับทราบ</b>,
      content: (
        <div className="login-consent">
          <h2>ข้อกำหนดและเงื่อนไขการใช้งานระบบจัดการสนามสอบ</h2>
          <ol>
            <li>ศึกษาคู่มือการใช้งานอย่างละเอียด</li>
            <li>ระบบมีฐานข้อมูลตั้งต้นให้ ศูนย์สอบสามารถเพิ่ม/ลด ข้อมูลห้องสอบได้เอง</li>
            <li>ตรวจสอบวันที่สอบ วิชาสอบ และห้องสอบ ให้ละเอียด</li>
            <li>หากปิดระบบแล้ว ส่วนกลางจะยึดข้อมูลล่าสุดที่ศูนย์สอบแก้ไขในระบบ </li>
          </ol>
        </div>
      ),
      onOk() { },
    });
  };

  return (
    <div>
      <Spin spinning={loggingIn}>
        <div className="t-body">
          <div className="t-login">
            <div className="t-form">
              <div className="text-center">
                <a href="/">
                  <img src="/img/logo.svg" alt="Logo" width="194" height="45" />
                </a>
                <h1>{!isResetPasswordState ? 'เข้าสู่ระบบศูนย์สอบ' : 'ตั้งค่ารหัสผ่านใหม่'}</h1>
              </div>
              <div className="_space">
                <label>
                  Email
                  <input
                    onKeyPress={_onKeyPress}
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    placeholder="Email"
                    type="text"
                  />
                  {emailError && <ErrorText>{emailError}</ErrorText>}
                </label>
              </div>
              {!isResetPasswordState && (
                <>
                  <div>
                    <label>
                      Password
                      <input
                        onKeyPress={_onKeyPress}
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        type="password"
                        placeholder="Password"
                      />
                      {passwordError && <ErrorText>{passwordError}</ErrorText>}
                    </label>
                  </div>
                  <div>
                    <Checkbox checked={isCheckedConsent} onChange={() => setIsCheckedConsent(!isCheckedConsent)}>
                      ข้าพเจ้ายอมรับ <a onClick={(e) => onShowModal(e)}>ข้อกำหนดและเงื่อนไขในการใช้บริการ</a>
                    </Checkbox>
                  </div>
                </>
              )}
              <div>
                <button
                  onClick={() => (isResetPasswordState ? onResetPassword() : onLogin())}
                  className={cn({
                    'btn-alt': !isCheckedConsent && !isResetPasswordState,
                  })}
                >
                  {' '}
                  {!isResetPasswordState ? 'เข้าสู่ระบบ' : 'ลืมรหัสผ่าน'}
                </button>
              </div>
            </div>
          </div>
        </div>

        <VideoModal isVisible={isVideoModalVisible} vimeoId={'642471244'} setIsVisible={setIsVideoModalVisible} />
      </Spin>
    </div>
  );
}

const ErrorText = styled.div`
  margin-top: 5px;
  font-size: 12px;
  color: ${getTheme`colors.red`};
`;
